import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  ILoadBalancerAllocation,
  ILoadBalancerAllocationRow,
} from '../../../../view/settings/api-automation-settings/load-balancer-allocations/load-balancer-allocations.model';

@Injectable({
  providedIn: 'root',
})
export class LoadBalancerAllocationService {
  private readonly LOAD_BALANCER_ALLOCATIONS_URL = `${this.baseUrl}/api-automation/load-balancer-allocations`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<ILoadBalancerAllocation>> {
    return this.http.get<GetManyResponseInterface<ILoadBalancerAllocation>>(this.LOAD_BALANCER_ALLOCATIONS_URL, {
      params,
    });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<ILoadBalancerAllocation>> {
    return this.http.get<BaseOneResponseInterface<ILoadBalancerAllocation>>(
      `${this.LOAD_BALANCER_ALLOCATIONS_URL}/${recordId}`,
      { params },
    );
  }

  public addOne(record: ILoadBalancerAllocationRow): Observable<BaseOneResponseInterface<ILoadBalancerAllocation>> {
    return this.http.post<BaseOneResponseInterface<ILoadBalancerAllocation>>(
      this.LOAD_BALANCER_ALLOCATIONS_URL,
      record,
    );
  }

  public editOne(
    recordId: number,
    record: ILoadBalancerAllocationRow,
  ): Observable<BaseOneResponseInterface<ILoadBalancerAllocation>> {
    return this.http.patch<BaseOneResponseInterface<ILoadBalancerAllocation>>(
      `${this.LOAD_BALANCER_ALLOCATIONS_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          loadBalancerAllocations: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(
        `${this.LOAD_BALANCER_ALLOCATIONS_URL}/bulk/delete`,
        httpOptions,
      );
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.LOAD_BALANCER_ALLOCATIONS_URL}/${recordIds[0]}`);
  }
}
